import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="not-found-page d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div className="text-center px-4">
        <div className="mb-4">
          <h1 className="display-1 fw-bold text-primary mb-0">404</h1>
        </div>
        <div className="mb-5">
          <h2 className="mb-3">Oops! Page Not Found</h2>
          <p className="lead mb-4">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <p className="text-muted">
            But don't worry, we can help you get back on track!
          </p>
        </div>
        
        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-5">
          <Link 
            to="/" 
            className="btn btn-primary btn-lg px-4"
          >
            <i className="ri-home-4-line me-2"></i>
            Back to Home
          </Link>
          <Link 
            to="/contact-us" 
            className="btn btn-outline-primary btn-lg px-4"
          >
            <i className="ri-customer-service-2-line me-2"></i>
            Contact Us
          </Link>
        </div>
        
        <div className="mt-4">
          <p className="small text-muted">
            Or try these popular pages:
          </p>
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <Link to="/loan-program" className="btn btn-sm btn-outline-secondary">Business Loans</Link>
            <Link to="/about-us" className="btn btn-sm btn-outline-secondary">About Us</Link>
            <Link to="/blog" className="btn btn-sm btn-outline-secondary">Blog</Link>
            <Link to="/faqs" className="btn btn-sm btn-outline-secondary">FAQs</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
